import { accountAPI } from 'services';
import MonthView from './MonthView';
import useOffcanvasStore from 'store/offcanvasStore';

const Header = ({ account, setAnimation, hideCancelled, handleToggle, goBack }) => {
  const { openOffcanvas } = useOffcanvasStore();
  const isSharedAccount = accountAPI.checkIsSharedAccount(account);
  const isSharedByMe = accountAPI.checkIsSharedByMe(account);

  const accountName = isSharedAccount ? account.get("sharedAcc")?.sharedBy : account.get("name");
  const headerClass = isSharedAccount || isSharedByMe ? "bg-app-accent" : "";

  return (
    <div className={`py-2 d-flex align-items-center flex-wrap px-2 shadow-sm ${headerClass}`}>
      <div className="col-12 col-md-9 d-flex align-items-center px-2" align="left">
        <i className="bi bi-arrow-left fs-3 me-2 me-md-3 d-md-none cursor-pointer"
          onClick={goBack}></i>
        <div className='d-flex align-items-center' onClick={() => openOffcanvas('editAccount')}>
          {account?.get("photo") ? (
            <img
              src={account.get("photo")}
              className="profile-img my-1 my-md-2 cursor-pointer "
              onError={(e) => {
                e.target.src = "https://placehold.co/150x150";
              }} />
          ) : (
            <i className="bi bi-person-circle text-app"
              style={{ fontSize: "40px" }} />
          )}

          <div className="ms-2 ms-md-4 cursor-pointer">
            <span className='fs-5 fs-md-4 d-block lh-1 text-truncate'>{accountName} 
              { (isSharedAccount || isSharedByMe ) && <span className="ms-2 badge rounded-pill text-bg-danger fs-6">Shared</span>}
            </span>
            <span className="fw-normal d-block" style={{ fontSize: "10px" }}>
              <i>View Profile</i>
            </span>
          </div>
        </div>
        <div className='mt-1 cursor-pointer ms-auto me-md-3' align="right">
          <i className={`fs-3 fs-md-2 text-app ${hideCancelled ? "bi-filter-circle-fill" : "bi-filter"}`}
            onClick={() => handleToggle(!hideCancelled)}></i>
        </div>
      </div>
      <div className='col-12 col-md-3 px-2 d-flex justify-content-between align-items-center'>
        <MonthView
          setAnimation={setAnimation}
        />
      </div>
    </div>
  )
}

export default Header;